
<!--
  Navigation bar
-->

<template lang="html">

  <div id="header">

    <div id="header-title">
      <router-link to="/">
        <img src="../../static/img/common/logo_header.svg" alt="Ralph Creative PR" />
      </router-link>
    </div>

    <div id="navbar">  
      <ul>
        <li>WEBSITE</li>
        <li>ARCHIVE</li>
        <li>CONTACT</li>
      </ul>
    </div>
    <!-- <div id="nav-social-module">  
      <ul id="nav-social-list">
          <li><a href="https://www.instagram.com/thechronophobe/" target="_blank"><img src="../../static/img/icons/footer_twitter.png" /></a></li>
          <li><a href="https://www.instagram.com/thechronophobe/" target="_blank"><img src="../../static/img/icons/footer_instagram.png" /></a></li>
          <li><a href="mailto:gulojoshua@gmail.com" target="_blank"><img src="../../static/img/icons/footer_email.png" /></a></li>
      </ul>
    </div> -->
    <div class="shadow"></div>
  </div>

</template>

<script>
export default {
  name: 'navbar'
}
</script>

<style>

  #header {
    height:73px;
    background-color: #ffffff;
    position: fixed;
    width: 100%;
    top:0;
    z-index: 99;
  }

  #header-title {
    height:100%;
    position: absolute;
    left:0px;
    top:0px;
  }
  #header-title img {
    height: 100%;
  }

  #navbar {
    float:right;
    height: 100%;
  }
  #navbar ul {
    list-style: none;
    margin: 0;
  }
  #navbar li {
    display: inline-block;
    margin:0 20px 0 0;
    font-size: 20px;
    line-height: 73px;
    cursor: pointer;
  }

 /* #nav-social-list {
    margin: 0;
  }
  #nav-social-list li img {
    width: 100%;
  }
  #nav-social-list li {
    vertical-align: top;
    display: inline-block;
    width: 73px;
    height:73px;
  }
  #nav-social-list li:hover {
    background-color: #000;
  }
*/
  .shadow{
      position: absolute;
      top: 73px;
      width: 0;
      height: 0;
      border-style: solid;
      float: right;
      right: 0;
      border-color: rgba(0,0,0,0.07) transparent transparent transparent;
          border-width: 35.6px 1141px 0px 0px;
  }

  @media only screen and (max-width: 620px) {
    #nav-nav {
      height:40px;
    }
    #nav-title {
      width:160px;
      left:10px;
      top:10px;
    }
    #nav-social-list li {
      width: 40px;
      height:40px;
    }
  }
</style>


// WEBPACK FOOTER //
// Navbar.vue?598500c2